import React, { memo, useEffect } from 'react';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';

import { changeProject, changeProjectFile, getProject } from '../../../redux/projects/projectsActions';
import { resetEditProjectPage } from '../../../redux/projects/projectsReducer';
import NameSection from '../name/NameSection';
import FileSection from '../file/FileSection';
import ShareSection from '../share/ShareSection';
import AccessUsersSection from '../access-users/AccessUsersSection';
import { PROJECT_TYPES } from '../../../constants';

import scss from './EditResonance.module.scss';

const EditResonance = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const handleSaveNameSection = ({ id, editProject, values }) => {
    const { projectName, theme, vision, dataStructure, lang } = values;

    dispatch(
      changeProject({
        id,
        projectType: editProject.projectType,
        values: {
          projectName,
          theme,
          vision,
          dataStructure,
          lang,
        },
      }),
    );
  };

  const handleChangeFile = (values, form) => {
    dispatch(changeProjectFile({ id, file: values.file, projectType: PROJECT_TYPES.RESONANCE })).then(() => {
      dispatch(getProject({ id })).then(() => {
        form.restart();
      });
    });
  };

  useEffect(() => {
    dispatch(getProject({ id }));

    return () => {
      dispatch(resetEditProjectPage());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={scss.pageWrapper}>
      <NameSection onSubmit={handleSaveNameSection} />
      <FileSection onSubmit={handleChangeFile} />
      <ShareSection />
      <AccessUsersSection />
    </div>
  );
};

export default memo(EditResonance);
